/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ListAzureSubnetsRequest {
  /**
  * The resource group containing the virtual network
  */
  'resourceGroup': string;
  /**
  * The name of the virtual network to list subnets from
  */
  'virtualNetworkName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceGroup",
      "baseName": "resourceGroup",
      "type": "string",
      "format": ""
    },
    {
      "name": "virtualNetworkName",
      "baseName": "virtualNetworkName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListAzureSubnetsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

